module.exports = __webpack_public_path__ + "static/33c6f4aa060feb082bce8813261f52ca.png";